
import React, { useState,useEffect } from 'react'   
// eslint-disable-next-line no-unused-vars
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
// import { useLocation } from 'react-router-dom';  

import CustomerConstantsList from './common/CustomerConstants';
import SupplierConstantsList, { RESET_PASSWORD } from './common/SupplierConstants';

import Page404 from './Pages/404Page';
import Login from './Pages/Login/Login';
import Register from './Pages/Login/Register';
import Company from './Pages/Settings/Company';
import Profile from './Pages/Settings/Profile';

// APP Dashboard
import AppLandingPage from './Pages/AppLandingPage';

// Customer_App START -----------------------------------------------------------------------------------------------------------------

// import CUSTOMER_HOME from './Pages/customer_app';
import CUSTOMER_HOME_INTRO from './Pages/customer_app/HomeIntro/HomeIntro';
import CUSTOMER_DASHBOARD from './Pages/customer_app/Dashboard';
import CUSTOMER_INBOX from './Pages/customer_app/Inbox';
import CUSTOMER_OUTBOX from './Pages/customer_app/Outbox'; 

// Customer_App END -----------------------------------------------------------------------------------------------------------------

// CUSTOMER V4 ==============================================
 
import CUSTOMER_V4_HB_HOME_PAGE from './Pages/customer_app/Customer_V4/HomePage/HbHomePage';
import CUSTOMER_V4_HB_LOGIN from './Pages/customer_app/Customer_V4/Login/HBLogin';
import CUSTOMER_V4_HB_EMPLOYEE from './Pages/customer_app/Customer_V4/Employee/HbEmployee';

import CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN from './Pages/customer_app/Customer_V4/MaterialPriceBreakDown/MaterilPriceBreakDownCreation';
import CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS from './Pages/customer_app/Customer_V4/MaterialPriceBreakDown/MaterilPriceBreakDownDetail';
import CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN from './Pages/customer_app/Customer_V4/Sales/CustomerSalesBreakDown';
import CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS from './Pages/customer_app/Customer_V4/Sales/CustomerSalesBreakDownDetails';
import CUSTOMER_V4_QUOTATION_ESTIMATE from './Pages/customer_app/Customer_V4/Quotation/QuotationEstimate';
import CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS from './Pages/customer_app/Customer_V4/Quotation/QuotationEstimateDetails';
import CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION from './Pages/customer_app/Customer_V4/FinancePriceBreakDown/FinancePriceBreakDownCreation';
import CUSTOMER_V4_HB_ESTIMATE_LIST from './Pages/customer_app/Customer_V4/Estimate/EstimateList';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_E1 from './Pages/customer_app/Customer_V4/Estimation/EstimationSpecification';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION from './Pages/customer_app/Customer_V4/Estimation/EstimationCreation';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_MATERIAL_DETAILS from './Pages/customer_app/Customer_V4/Estimation/EstimationCreationDetail';
import CUSTOMER_V4_HB_MATERIAL_LIST from './Pages/customer_app/Customer_V4/Material/Material';

import CUSTOMER_V4_HB_QUOTATION_LIST from './Pages/customer_app/Customer_V4/Quotation_V1/QuotationList';
import CUSTOMER_V4_HB_ENTRY_LIST from './Pages/customer_app/Customer_V4/Entry/EntryList';
import CUSTOMER_V4_HB_JOB_LIST from './Pages/customer_app/Customer_V4/Job_HB/JobList';

import CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST from './Pages/customer_app/Customer_V4/Estimation/EstimationList';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS from './Pages/customer_app/Customer_V4/Estimation/EstimationDetails';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION from './Pages/customer_app/Customer_V4/Estimation/EstimationDetailsRevision';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW from './Pages/customer_app/Customer_V4/EstimationWorkFlow/EstimationSpecificationWorkFlow';
import CUSTOMER_V4_CUSTOMER_ESTIMATE_CREATION__WORKFLOW from './Pages/customer_app/Customer_V4/EstimationWorkFlow/EstimationCreationworkFlow';

//REPORTS
import CUSTOMER_REPORTS from './Pages/customer_app/Report/CustomerReports';
import CUSTOMER_REPORT_DETAILS from './Pages/customer_app/Report/ReportsDetail/CustomerReportsDetails';

import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { initializeAppData } from './AppDataUtils';

// Redux
import { addAppInfo, appConfigFunc, updateAppCode } from './redux/feature/appSlice';
import usePageTracking from './usePageTracking';

// Assume this is your authentication check function
// eslint-disable-next-line no-unused-vars
const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return !!token;
};

const PrivateRoute = ({ children }) => {
    // const location = useLocation();
    // console.log(">> AppRouters >> user isAuthenticated >> " , isAuthenticated());

    // let check = checkHrefLink(menuData, location.pathname);
    // console.log(">> check", check);
    // console.log(">> location.pathname", location.pathname);
    // if(check){
    //     return isAuthenticated() ? children : <Navigate to="/login" />;
    // }else{

    //     return isAuthenticated() ? <Navigate to="/home" /> : <Navigate to="/login" />;
    // }    
    usePageTracking();
    // return isAuthenticated() ? children : <Navigate to="/login" />;
    return children
};

// const checkHrefLink = (arr, url) => {
//     for (let item of arr) {
//         if (item.hrefLink === url) {
//             return true;
//         }
//         if (item.children) {
//             const foundInChildren = checkHrefLink(item.children, url);
//             if (foundInChildren) return true;
//         }
//     }
//     return false;
// };

function AppRouters() {

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    
    const [getUserData, setUserData] = useState([]);

    useEffect(() => {
        dispatch(appConfigFunc());
        changeLanguage("en"); // kannada, tamil, en, ae
        console.log(">> lang:", t('msg_name'));
        let localData = localStorage.getItem('userData');
        let userData={}
        if(localData){
            userData = JSON.parse(localData);
            dispatch(addAppInfo(userData));  
            setUserData(userData)           
        }  
        
    // eslint-disable-next-line          
    },[]);

    useEffect(() => {       
        if (getUserData?.data) {
            // console.log(">> App Router >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", getUserData);            
            let appCode = localStorage.getItem('application');            
            if(appCode === "SUPPLIER"){
                initializeAppData(dispatch, appCode);
                dispatch(updateAppCode(appCode));
            }else if(appCode === "CUSTOMER"){
                initializeAppData(dispatch, appCode);
                dispatch(updateAppCode(appCode));
            }else{
                initializeAppData(dispatch, appCode);
            }
        }

     // eslint-disable-next-line          
    },[dispatch, getUserData]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return(
        <>  
            {/* <Page404/> */}
            <Routes>                                      
                {/* Public route */}
                <Route exact path='*' element={<Page404 />}></Route>
                {/* <Route exact path='/' element={<Login />}></Route>       */}
                <Route exact path={SupplierConstantsList.LOGIN} element={<Login/>}></Route>                
                <Route exact path={SupplierConstantsList.REGISTER} element={<Register/>}></Route>    
                <Route exact path={SupplierConstantsList.RESET_PASSWORD} element={<RESET_PASSWORD />}></Route>
                {/* Private route */}
                
                <Route  exact path={SupplierConstantsList.COMPANY}  element={ <PrivateRoute>  <Company/>  </PrivateRoute>  } />
                <Route  exact path={SupplierConstantsList.PROFILE}  element={ <PrivateRoute> <Profile/>  </PrivateRoute>  } />

               
                {/* ----------------------------------  Customer START  ---------------------------------- */}

                {/* Common */}
                <Route exact path='/' element={<CUSTOMER_V4_HB_HOME_PAGE />}></Route> 
                
                <Route  exact path={SupplierConstantsList.APP_HOME}  element={ <PrivateRoute> <AppLandingPage/>  </PrivateRoute>  } />
                {/* <Route  exact path={CustomerConstantsList.HOME}  element={ <PrivateRoute> <HOME/>  </PrivateRoute>  } /> */}
                <Route  exact path={CustomerConstantsList.HOME_INTRO}  element={ <PrivateRoute> <CUSTOMER_HOME_INTRO/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.DASHBOARD}  element={ <PrivateRoute> <CUSTOMER_DASHBOARD/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.INBOX}  element={ <PrivateRoute> <CUSTOMER_INBOX/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.OUTBOX}  element={ <PrivateRoute> <CUSTOMER_OUTBOX/>  </PrivateRoute>  } />


                {/*====================== CUSTOMER V4 ==========================*/}
 
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_LOGIN}  element={ <PrivateRoute> <CUSTOMER_V4_HB_LOGIN/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_HOME_PAGE}  element={ <PrivateRoute> <CUSTOMER_V4_HB_HOME_PAGE/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_EMPLOYEE}  element={ <PrivateRoute> <CUSTOMER_V4_HB_EMPLOYEE/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN}  element={ <PrivateRoute> <CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS}  element={ <PrivateRoute> <CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_QUOTATION_ESTIMATE}  element={ <PrivateRoute> <CUSTOMER_V4_QUOTATION_ESTIMATE/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS}  element={ <PrivateRoute> <CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION}  element={ <PrivateRoute> <CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_QUOTATION_LIST}  element={ <PrivateRoute> <CUSTOMER_V4_HB_QUOTATION_LIST/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_JOB_LIST}  element={ <PrivateRoute> <CUSTOMER_V4_HB_JOB_LIST/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_ESTIMATE_LIST}  element={ <PrivateRoute> <CUSTOMER_V4_HB_ESTIMATE_LIST/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_E1}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_E1/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_MATERIAL_DETAILS}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_MATERIAL_DETAILS/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_MATERIAL_LIST}  element={ <PrivateRoute> <CUSTOMER_V4_HB_MATERIAL_LIST/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_HB_ENTRY_LIST}  element={ <PrivateRoute> <CUSTOMER_V4_HB_ENTRY_LIST/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW/>  </PrivateRoute>  } />
                <Route  exact path={CustomerConstantsList.CUSTOMER_V4_CUSTOMER_ESTIMATE_CREATION__WORKFLOW}  element={ <PrivateRoute> <CUSTOMER_V4_CUSTOMER_ESTIMATE_CREATION__WORKFLOW/>  </PrivateRoute>  } />
                
                 {/* Reports */}
                 <Route  exact path={CustomerConstantsList.CUSTOMER_REPORTS}  element={ <PrivateRoute> <CUSTOMER_REPORTS/>  </PrivateRoute>} />
                 <Route  exact path={CustomerConstantsList.CUSTOMER_REPORT_DETAILS}  element={ <PrivateRoute> <CUSTOMER_REPORT_DETAILS/>  </PrivateRoute>}/>
            </Routes>  
            {/* <Footer/> */}
        </>
    );
}


export default AppRouters;